Ext.define('SA.model.map.Extent', {
    extend: 'Ext.data.Model',
    mixins: ['SA.model.ObservableChangeMixin'],

    statics: {
        fromBounds(bounds) {
            return new this(this.toData(bounds));
        },

        toData(bounds) {
            if (bounds.getBounds) {
                bounds = bounds.getBounds();
            }

            return {
                minX: bounds[0], 
                minY: bounds[1], 

                maxX: bounds[2], 
                maxY: bounds[3]  
            };
        },

        toSides(bounds) {
            return this.fromBounds(bounds).toSides();
        }
    },

    fields: [
        {
            mapping: 'minx',
            name: 'minX',
            type: 'number'
        }, {
            mapping: 'maxx',
            name: 'maxX',
            type: 'number'
        }, {
            mapping: 'miny',
            name: 'minY',
            type: 'number'
        }, {
            mapping: 'maxy',
            name: 'maxY',
            type: 'number'
        }
    ],

    clone() {
        return this.statics().fromBounds(this);
    },

    getAspectRatio() {
        return this.getHeight() / this.getWidth();
    },

    getBottom() {
        return this.getMinY();
    },

    getBounds() {
        return [this.getLeft(), this.getBottom(), this.getRight(), this.getTop()];
    },

    getHeight() {
        return this.getTop() - this.getBottom();
    },

    getLeft() {
        return this.getMinX();
    },

    getMaxX(){
        return this.get('maxX');
    },

    getMaxY(){
        return this.get('maxY');
    },

    getMinX(){
        return this.get('minX');
    },

    getMinY(){
        return this.get('minY');
    },

    getRight() {
        return this.getMaxX();
    },

    getSize() {
        return {
            height: this.getHeight(),
            width: this.getWidth()
        };
    },

    getTop() {
        return this.getMaxY();
    },

    getWidth() {
        return this.getRight() - this.getLeft();
    },

    setBounds(bounds) {
        this.setWithEvent(this.statics().toData(bounds), 'set:bounds');
    },

    setHeight(height) {
        var bottom = (this.getTop() + this.getBottom() - height) / 2;

        this.setWithEvent({
            minY: bottom,
            maxY: bottom + height
        }, 'set:bounds');
    },

    setSize(size) {
        this.setHeight(size.height);
        this.setWidth(size.width);
    },

    setWidth(width) {
        var left = (this.getLeft() + this.getRight() - width) / 2;

        this.setWithEvent({
            minX: left,
            maxX: left + width
        }, 'set:bounds');
    },

    toLatLon() {
        return {
            x: (this.getLeft() + this.getRight()) / 2,
            y: (this.getTop() + this.getBottom()) / 2
        };
    },

    toSides() {
        return {
            bottom: this.getBottom(),
            left: this.getLeft(),
            right: this.getRight(),
            top: this.getTop()
        };
    }
});